import React, { Component } from "react"
import Svg from "../../../shared/_svgs/svg"
import { isMobile } from "react-device-detect"
import Slider from "react-slick"

export default class MerchantFurtherInspiration extends Component {
  constructor(props) {
    super(props)

    this.state = {
      linkItems: props.linkItems,
    }
  }

  renderFurtherInspirationLinks = (linkItems) => {
    if (linkItems.length > 0) {
      return linkItems?.map((item, index) => {
        return (
          <div className="spot-box__item" key={`furtherInspirationLink${index}`}>
            <div className="image">
              <div className={`on-img-text ${item.shopNameBlue ? "cph-blue" : ""}`}>{item.shopName}</div>
              <img src={item.image} />
            </div>
            <ul className="linkgroup">
              {item.uspList &&
                item.uspList.map((usp, uspIndex) => {
                  return (
                    <li key={`usp${uspIndex}`}>
                      <a href={usp.link} className="linkitem">
                        <Svg iconName={usp.icon} fillColor={"#071143"} />
                        {usp.text}
                      </a>
                    </li>
                  )
                })}
            </ul>
            <div className="visitlink">
              <a href={item.buttonLink} className="linkitem">
                <Svg iconName={"arrowright"} fillColor={"#071143"} />
                {item.buttonText}
              </a>
            </div>
            <div className="clear"></div>
          </div>
        )
      })
    }
  }

  render() {
    var settings = {
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      variableWidth: true,
    }

    return isMobile ? (
      <div className={"further-inspiration-slider"}>
        <Slider {...settings}>{this.state.linkItems && this.renderFurtherInspirationLinks(this.state.linkItems)}</Slider>
      </div>
    ) : (
      <div>{this.state.linkItems && this.renderFurtherInspirationLinks(this.state.linkItems)}</div>
    )
  }
}
